import React, { useEffect, useRef, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
  Select,
  Tabs,
  Tab,
  Modal,
  Button,
  IconButton,
} from "@mui/material";
import { Delete, Edit, Search } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import stateList from "../../data/states.json";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import {
  MAIN_URL,
  decodeToken,
  getApiCall,
  postApiCall,
  postFormApiCall,
} from "../../utils/api";
import tableIcons from "../component/MaterialIcon";
import EditSchool from "./modal/EditSchool";
import ImageEdit from "./modal/ImageEditModal";
import ViewAllStudentBySchool from "./ViewAllStudentBySchool";
import SchoolIndividual from "./modal/addschooltabs/schoolindividual";
import SchoolBulk from "./modal/addschooltabs/schoolbulk";
import { Download } from "@mui/icons-material";

const Schools = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  const [data, setData] = useState([]);
  const [bannerName, setBannerName] = useState("");

  const [bannerId, setBannerId] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const imageFileInputRef = useRef(null);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // setStudentData([])
    fetchData();
  }, []);
  const [loggedUser, setLoggedUser] = useState({});
  const fetchData = async () => {
    setLoading(true);

    const resData = await decodeToken();
    setLoggedUser(resData.user);
    const res = await getApiCall("admin/get-all-schools");
    // console.log(res.data);

    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("id", bannerId);
    formData.append("name", bannerName);
    formData.append("status", isChecked);
    formData.append("banner_img", imageFile);

    let res = {};
    if (bannerId === "") {
      res = await postFormApiCall("banner/add", formData);
    } else {
      res = await postFormApiCall("banner/update", formData);
    }
    setLoading(false);

    if (res.error === true) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    if (imageFileInputRef.current) {
      imageFileInputRef.current.value = "";
    }

    setBannerId("");
    setBannerName("");
    setImageFile(null);
    fetchData();
  };

  let navigate = useNavigate();
  const handleNameClick = async (rowData) => {
    const res = await getApiCall(
      "admin/getAllStudentBySchool/" + rowData.id.toString(),
    );
    if (res.data.length <= 0)
      return Swal.fire({
        title: "Error",
        text: "Student Not Assign to this School",
        icon: "error",
      });
    navigate("/view-all-students-by-school", {
      state: {
        studentData: res.data.map((data, index) => ({
          ...data,
          serial: index + 1,
        })),
        schoolName: res.data.length > 0 ? res.data[0]["schoolname"] : "",
      },
    });
  };

  const [selectedIds, setSelectedIds] = useState([]);

  const handleSelectRow = (id) => {
    setSelectedIds(
      (prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id], // select
    );
  };

  const columns = [
    {
      title: "Select",
      render: (rowData) => (
        <input
          type="checkbox"
          checked={selectedIds.includes(rowData.id)}
          onChange={() => handleSelectRow(rowData.id)}
        />
      ),
      width: "5%",
    },
    { title: "Id", field: "id", width: "10%" },
    {
      title: "Image",
      field: "banner_img",
      render: (rowData) => {
        return (
          <div style={{ position: "relative" }}>
            <img src={rowData.image} height={50} width={50} />
            <Edit
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                color: "gray",
                cursor: "pointer",
                transition: "color 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.color = "blue")}
              onMouseLeave={(e) => (e.target.style.color = "gray")}
              onClick={() => handleImageModalOpen(rowData)}
            />
          </div>
        );
      },
    },
    {
      title: "Name",
      field: "name",
      render: (rowData) => {
        return (
          <div
            style={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => handleViewAnalytics(rowData)}
          >
            {rowData.name}
          </div>
        );
      },
    },
    { title: "Co-ordinator", field: "user_name" },
    {
      title: "Co-ordinator Email",
      field: "user_email",
      render: (rowData) => (
        <a
          href={`mailto:${rowData.user_email}`}
          style={{ textDecoration: "none", color: "blue" }}
        >
          {rowData.user_email}
        </a>
      ),
    },
    {
      title: "Phone",
      field: "phone",
      render: (rowData) => (
        <a
          href={`tel:${rowData.phone}`}
          style={{ textDecoration: "none", color: "blue" }}
        >
          {rowData.phone}
        </a>
      ),
    },
    { title: "Type", field: "school_type" },
    { title: "Address", field: "address" },
    { title: "Total registered Students", field: "total_registered_students" },
    { title: "Total Students", field: "total_original_students" },
    {
      title: "Total Olympiad Registered Students",
      field: "total_olympiad_registered_students",
    },
    // { title: "Start Road Safety Club?", field: "start_road_safety_club" },
    // { title: "Know About School?", field: "is_know_about_school" },
  ];

  const [openImage, setOpenImage] = useState(false);
  const handleImageModalOpen = async (rowData) => {
    setOpenImage(true);
    setRowData(rowData);
  };
  const handleUpdateImage = async (updatedData) => {
    setOpenImage(false);

    const formData = new FormData();

    formData.append("id", updatedData.id);
    formData.append("imagefile", updatedData.image);
    const res = await postFormApiCall("admin/update-school-image", formData);
    setRowData(null);

    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    fetchData();
  };

  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const handleEdit = async (rowData) => {
    setRowData(rowData);
    setOpen(true);
  };
  // useEffect(() => {
  //   if (rowData) {
  //     setOpen(true);
  //   }
  // }, [rowData]);

  const handleUpdate = async (updatedData) => {
    // console.log("Updated Data:", updatedData);
    setOpen(false);
    const res = await postApiCall("admin/update-school-details", updatedData);
    setRowData(null);

    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    fetchData();
  };

  const [cityList, setCityList] = useState([]);
  const [filterData, setFiterData] = useState({
    state: "",
    city: "",
  });
  const handleChange = async (event) => {
    setLoading(true);
    const { name, value } = event.target;
    const updatedFilterData = {
      ...filterData,
      [name]: value,
    };
    if (name === "state") {
      const selectedState = stateList.states.find(
        (state) => state.state_code === value,
      );
      setCityList(selectedState ? selectedState.cities : []);
      updatedFilterData.city = "";
    }
    setFiterData(updatedFilterData);
    const res = await postApiCall(
      `admin/school/filterByStateAndCity`,
      updatedFilterData,
    );
    setLoading(false);

    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
  };

  const [isOpen, setIsOpen] = useState(false);
  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
  };

  const handleViewAnalytics = (rowData) => {
    const url = `/schoolanalytics?id=${rowData.id}&name=${encodeURIComponent(
      rowData.name,
    )}`;

    window.open(url, "_blank", "noopener,noreferrer");
    // navigate("/schoolanalytics", {
    //   state: {
    //     id: rowData.id,
    //     name: rowData.name,
    //   },
    // });
  };
  const tableRef = React.useRef(null);
  // const mergeSchools = () => {
  //   if (selectedIds.length < 2) return;

  //   // build radio list HTML
  //   const radioOptions = selectedIds
  //     .map(
  //       (id, index) => `
  //       <div style="text-align:left; margin:5px 0;">
  //         <input type="radio" name="primarySchool" value="${id}" ${
  //           index === 0 ? "checked" : ""
  //         } />
  //         <label style="margin-left:8px;">School ID: ${id}</label>
  //       </div>
  //     `,
  //     )
  //     .join("");

  //   Swal.fire({
  //     title: "Select Primary School",
  //     html: `
  //     <div style="margin-bottom:10px;">Choose primary school:</div>
  //     ${radioOptions}
  //   `,
  //     icon: "question",
  //     customClass: {
  //       icon: "small-swal-icon",
  //     },
  //     showCancelButton: true,
  //     confirmButtonText: "Merge",
  //     preConfirm: () => {
  //       const selected = document.querySelector(
  //         'input[name="primarySchool"]:checked',
  //       );
  //       if (!selected) {
  //         Swal.showValidationMessage("Please select a primary school");
  //         return false;
  //       }
  //       return selected.value;
  //     },
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       const primaryId = result.value;

  //       const res = await postApiCall("admin/merge-schoolsttt", {
  //         ids: selectedIds,
  //         primaryId: primaryId,
  //       });

  //       if (res.success === false) {
  //         return Swal.fire({
  //           title: "Error",
  //           text: res.message,
  //           icon: "error",
  //         });
  //       }

  //       setSelectedIds([]);

  //       Swal.fire({
  //         title: "Successful",
  //         text: res.message,
  //         icon: "success",
  //       });

  //       fetchData();
  //     }
  //   });
  // };

  // const mergeSchools = () => {
  //   // console.log(selectedIds);
  //   new Swal({
  //     title: "Are you sure, you want to merge the selected schools ?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       const res = await postApiCall("admin/merge-schools", {
  //         ids: selectedIds,
  //       });
  //       // console.log(res);

  //       if (res.success === false) {
  //         return Swal.fire({
  //           title: "Error",
  //           text: res.message,
  //           icon: "error",
  //         });
  //       }
  //       setSelectedIds([]);
  //       Swal.fire({
  //         title: "Successful",
  //         text: res.message,
  //         icon: "success",
  //       });
  //       fetchData();
  //     }
  //   });
  // };

  const mergeSchools = () => {
    if (selectedIds.length < 2) return;

    // get full row objects of selected schools
    const selectedRows = data.filter((row) => selectedIds.includes(row.id));

    // build radio list with name + id
    const radioOptions = selectedRows
      .map(
        (row, index) => `
        <div style="text-align:left;margin:6px 0;padding:6px;border-radius:6px;background:#f8f9fa;">
          <input type="radio" name="primarySchool" value="${row.id}" ${
            index === 0 ? "checked" : ""
          } />
          <label style="margin-left:8px;font-weight:500;">
            ${row.name}
            <span style="color:#777;font-size:12px;"> (ID: ${row.id})</span>
          </label>
        </div>
      `,
      )
      .join("");

    Swal.fire({
      title: "Select Primary School",
      html: `
      <div style="margin-bottom:10px;font-size:14px;">
        Choose which school should remain as primary:
      </div>
      ${radioOptions}
    `,
      icon: "question",
      width: "80%",
      showCancelButton: true,
      confirmButtonText: "Merge",
      preConfirm: () => {
        const selected = document.querySelector(
          'input[name="primarySchool"]:checked',
        );

        if (!selected) {
          Swal.showValidationMessage("Please select a primary school");
          return false;
        }

        return selected.value;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const primaryId = result.value;
        const otherIds = selectedIds.filter((id) => id !== Number(primaryId));

        const res = await postApiCall("admin/merge-schools", {
          ids: otherIds,
          primaryId,
        });

        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }

        setSelectedIds([]);

        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });

        fetchData();
      }
    });
  };

  const searchClick = async (searchText) => {
    const result = await getApiCall(
      `admin/search-schools?search=${searchText}`,
    );
    // console.log(result);
    setData(result.data);
    result.data.forEach((data, index) => {
      data.serial = index + 1;
    });
  };
  const downloadAllSchool = async () => {
    setLoading(true);
    const result = await getApiCall(`admin/download-all-schools`);
    setLoading(false);
    downloadCSV(result.data);
  };

  const downloadCSV = (data, fileName = "schools.csv") => {
    if (!data || !data.length) return;

    // Add serial number at the beginning
    const cleanedData = data.map((row, index) => {
      const { tableData, ...rest } = row; // remove material-table metadata if any
      return {
        serial: index + 1,
        ...rest,
      };
    });

    const csv = Papa.unparse(cleanedData);

    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
  return (
    <div>
      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" gutterBottom>
            Add School
          </Typography>
          <Tabs value={tab} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Individual" />
            <Tab label="Bulk" />
          </Tabs>

          <Box sx={{ mt: 2 }}>
            {tab === 0 && (
              <SchoolIndividual setIsOpen={setIsOpen} fetchData={fetchData} />
            )}
            {tab === 1 && (
              <SchoolBulk setIsOpen={setIsOpen} fetchData={fetchData} />
            )}
          </Box>
        </Box>
      </Modal>

      {rowData && (
        <EditSchool
          key={rowData?.id}
          open={open}
          onClose={() => setOpen(false)}
          rowData={rowData}
          onUpdate={handleUpdate}
        />
      )}
      {rowData && (
        <ImageEdit
          key={rowData?.id}
          open={openImage}
          onClose={() => setOpenImage(false)}
          rowData={rowData}
          onImageUpdate={handleUpdateImage}
        />
      )}
      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">School</h4>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Schools</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <button
                  className="btn btn-primary"
                  onClick={() => setIsOpen(true)}
                >
                  + Add School
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-3">
          <div className="container-fluid">
            {loggedUser.role == "admin" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <button
                  aria-label="search"
                  className="btn btn-success"
                  onClick={() => downloadAllSchool()}
                >
                  <Download /> Download All School
                </button>
                <div>
                  <TextField
                    variant="standard"
                    placeholder="Search School"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <IconButton
                    aria-label="delete"
                    onClick={() => searchClick(searchText)}
                  >
                    <Search />
                  </IconButton>
                </div>
              </div>
            )}
            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                tableRef={tableRef}
                // key={searchTrigger}
                icons={tableIcons}
                title=""
                columns={columns}
                data={data}
                onRowClick={(evt, selectedRow) =>
                  setSelectedRow(selectedRow.tableData.id)
                }
                options={{
                  pageSize: 10,
                  pageSizeOptions: [10, 50, 100, 1000],
                  search: false,
                  exportButton: true,
                  exportCsv: (columns, data) => {
                    const cleanedData = data.map((row, index) => {
                      const { tableData, ...rest } = row;
                      return { serial: index + 1, ...rest };
                    });

                    // Extract fields dynamically
                    const fields = Object.keys(cleanedData[0] || {});

                    // Generate CSV
                    const csv = Papa.unparse({
                      fields,
                      data: cleanedData.map((row) =>
                        fields.map((f) => row[f] ?? ""),
                      ),
                    });

                    // Download file
                    const blob = new Blob([csv], {
                      type: "text/csv;charset=utf-8;",
                    });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "school.csv");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  },

                  exportPdf: (columns, data) => {
                    const doc = new jsPDF();

                    // Prepare cleaned data
                    const cleanedData = data.map((row, index) => {
                      const { tableData, ...rest } = row;
                      return { serial: index + 1, ...rest };
                    });

                    const fields = Object.keys(cleanedData[0] || {});

                    const tableRows = cleanedData.map((row) =>
                      fields.map((f) => row[f] ?? ""),
                    );

                    autoTable(doc, {
                      head: [fields],
                      body: tableRows,
                      styles: { fontSize: 8 },
                      headStyles: { fillColor: [0, 123, 255] },
                    });

                    doc.save("school.pdf");
                  },

                  // exportPdf: (columns, data) => {
                  //   const doc = new jsPDF();
                  //   const tableColumnTitles = columns.map((col) => col.title);
                  //   const tableRows = data.map((row) =>
                  //     columns.map((col) => row[col.field] ?? "")
                  //   );

                  //   autoTable(doc, {
                  //     head: [tableColumnTitles],
                  //     body: tableRows,
                  //     styles: { fontSize: 8 },
                  //     headStyles: { fillColor: [0, 123, 255] },
                  //   });

                  //   doc.save("school.pdf");
                  // },
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: "rgb(0 123 255)",
                    color: "#FFF",
                    fontSize: 18,
                  },
                  rowStyle: (rowData, index) => ({
                    backgroundColor:
                      selectedRow === rowData.tableData.id
                        ? "#d3d4d1"
                        : index % 2 !== 0
                          ? "#EEE"
                          : "#FFF",
                  }),
                }}
                components={{
                  Toolbar: (props) => (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      padding="10px"
                    >
                      {/* Left Side: Title */}
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        Schools
                      </Typography>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {loggedUser.role == "admin" && (
                          <>
                            <button
                              className="btn btn-primary"
                              onClick={() => mergeSchools()}
                              disabled={selectedIds.length < 2}
                              style={{ marginRight: "16px" }}
                            >
                              Merge Schools
                            </button>
                            <FormControl
                              sx={{ width: "200px", marginRight: "16px" }}
                            >
                              <Select
                                sx={{ height: "40px" }}
                                name="state"
                                value={filterData.state}
                                onChange={handleChange}
                                displayEmpty
                              >
                                <MenuItem value="" disabled>
                                  Select State
                                </MenuItem>
                                {stateList.states
                                  ?.sort((a, b) => a.name.localeCompare(b.name))
                                  ?.map((state) => (
                                    <MenuItem
                                      key={state.state_code}
                                      value={state.state_code}
                                    >
                                      {state.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>

                            <FormControl
                              sx={{ width: "200px", marginRight: "16px" }}
                            >
                              <Select
                                sx={{ height: "40px" }}
                                name="city"
                                value={filterData.city}
                                onChange={handleChange}
                                displayEmpty
                              >
                                <MenuItem value="" disabled>
                                  Select City
                                </MenuItem>
                                {cityList.map((city) => (
                                  <MenuItem key={city} value={city}>
                                    {city}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        )}
                        <MTableToolbar {...props} />
                      </Box>
                    </Box>
                  ),
                }}
                actions={[
                  // View Analytics — visible to all users
                  {
                    icon: () => (
                      <span style={{ color: "#009688" }}>
                        <i className="fas fa-users"></i>
                      </span>
                    ),
                    tooltip: "View Students",
                    onClick: (event, rowData) => handleNameClick(rowData),
                  },
                  // Edit — only for admin
                  ...(loggedUser.role === "admin"
                    ? [
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                      ]
                    : []),
                ]}
              />
            </ThemeProvider>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Schools;
